import { RibaModule } from '@ribajs/core'
import { extend } from '@ribajs/utils/src/type.js'
import { TwModuleOptions } from './types/index'

import * as binders from './binders/index'
import * as components from './components/index'
import * as services from './services/index'
import * as constants from './constants/defaults'

export const TwModule: RibaModule<Partial<TwModuleOptions>> = {
  binders,
  services,
  formatters: {},
  components,
  constants,
  init(partialOptions = {}) {
    const options = extend(
      { deep: true, keepValues: true },
      partialOptions,
      constants.DEFAULT_MODULE_OPTIONS,
    ) as TwModuleOptions
    services.TwService.setSingleton(options)
    return this
  },
}
